import { Configs } from './Configs';
import { defaults } from './defaults';

const configs: Configs = {
  authEnabled: defaults.auth_enabled,
  authTokenGeneratorUrl: defaults.auth_token_generator,
  emailValidatorUrl: defaults.email_validator_url,
  phoneValidatorUrl: defaults.phone_validator_url,
  testAds: defaults.test_ads,
  coreApiUrl: defaults.api_base_url,
};

export default configs;
